import $ from 'jquery';

$( '.featured-products__products' ).each( function () {
	const $featuredProductsHead = $( this ).parent( '.woocommerce' ).prev( '.featured-products__head' );

	$( this ).slick( {
		infinite: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		prevArrow: $featuredProductsHead.find( '.featured-products__head-nav-prev' ),
		nextArrow: $featuredProductsHead.find( '.featured-products__head-nav-next' ),
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
				}
			},
		]
	} );
} );

